export default {
  purchasePlacesLoading: true,
  purchasePlaces: [],
  serialNumberMandatory: false,
};
